import AppContext from "configurator-studio-arkitekter-components/dist/common/components/App/context";

export default AppContext;
